import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { login as loginAPI } from '../../lib/api/user-api';
import { redirectToNaverAuthorize } from '../../lib/naver-auth';
import './LoginPage.css';

function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    userId: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await loginAPI(formData.userId, formData.password);

      if (response.success) {
        login(response.data);
        navigate('/home');
      } else {
        setError(response.message || '로그인에 실패했습니다.');
      }
    } catch (err) {
      console.error('로그인 에러:', err);
      setError(err.message || '로그인 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleSignupClick = () => {
    navigate('/signup');
  };

  // 네이버 로그인: 인가 페이지로 이동
  const handleNaverLogin = () => {
    try {
      redirectToNaverAuthorize();
    } catch (e) {
      setError(e.message || '네이버 로그인을 시작할 수 없습니다.');
    }
  };

  return (
    <div className="login_page">
      <div className="login_container">
        <div className="login_header">
          <img src="/logo.png" alt="RANKER" className="login_logo" />
          <p>아파트 투자 랭킹 분석 플랫폼</p>
        </div>

        <form className="login_form" onSubmit={handleSubmit}>
          {error && <div className="login_error-message">{error}</div>}

          <div className="login_form-group">
            <label htmlFor="userId">아이디</label>
            <input
              type="text"
              id="userId"
              name="userId"
              value={formData.userId}
              onChange={handleChange}
              placeholder="아이디를 입력하세요"
              required
              disabled={loading}
            />
          </div>

          <div className="login_form-group">
            <label htmlFor="password">비밀번호</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="비밀번호를 입력하세요"
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="login_button" disabled={loading}>
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className="login_social">
          <button
            type="button"
            className="login_naver-btn"
            onClick={handleNaverLogin}
            disabled={loading}
            aria-label="네이버로 로그인"
          >
            <img src="/assets/naver_login_btn.png" alt="네이버로 로그인" />
          </button>
        </div>

        <div className="login_footer">
          <button onClick={handleSignupClick} className="login_signup-link">
            회원가입
          </button>
          <div className="login_find-links">
            <a href="#find-id">아이디 찾기</a>
            <span>|</span>
            <a href="#find-password">비밀번호 찾기</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
